import { Link } from "react-router-dom";
import { ArrowRight, Building2, ClipboardCheck, UserRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DrugTestingHero,
  DrugTestingPageShell,
  SampleTypeChoices,
  useDrugTestingCopy
} from "@/components/site/drug-testing/DrugTestingShared";
import { SamplingLocationsSection } from "@/components/site/SamplingLocationsSection";
import { companyPaths } from "@/data/company";
import { drugTestingHref } from "@/data/drugTesting";
import { PageMeta } from "@/components/site/PageMeta";

const Drogtestning = () => {
  const { lang, copy } = useDrugTestingCopy();
  const h = copy.hub;



  const purposes = [
    {
      icon: Building2,
      title: h.companyTitle,
      text: h.companyText,
      cta: h.companyCta,
      to: companyPaths.drogtestning[lang],
    },
    {
      icon: ClipboardCheck,
      title: h.intygTitle,
      text: h.intygText,
      cta: h.intygCta,
      to: drugTestingHref("forIntyg", lang),
    },
    {
      icon: UserRound,
      title: h.privatTitle,
      text: h.privatText,
      cta: h.privatCta,
      to: drugTestingHref("privat", lang),
    },
  ];

  return (
    <DrugTestingPageShell>
      <PageMeta title={h.metaTitle} description={h.metaDescription} />
      <DrugTestingHero label={h.label} title={h.title}>
        <p>{h.subtitle}</p>
        <div className="flex flex-col gap-3 pt-2 sm:flex-row sm:flex-wrap sm:items-center">
          <Button asChild variant="hero" size="xl" className="w-full sm:w-auto">
            <a href="#provtyper">
              {h.primaryCta}
              <ArrowRight className="ml-2 h-4 w-4" />
            </a>
          </Button>
          <span className="text-sm font-medium text-foreground">{h.priceNote}</span>
        </div>
      </DrugTestingHero>

      <section id="valj-andamal" className="scroll-mt-24 py-14 lg:py-16">
        <div className="container-wide">
          <h2 className="font-display text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
            {h.purposeTitle}
          </h2>
          <div className="mt-8 grid gap-5 md:grid-cols-3">
            {purposes.map((item) => {
              const Icon = item.icon;
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className="group flex flex-col rounded-3xl border border-border/60 bg-card p-7 shadow-card transition-smooth hover:-translate-y-1 hover:border-primary/30 hover:shadow-elevated"
                >
                  <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-primary-soft text-primary">
                    <Icon className="h-5 w-5" aria-hidden />
                  </span>
                  <h3 className="mt-5 font-display text-xl font-semibold text-foreground">{item.title}</h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-muted-foreground">{item.text}</p>
                  <span className="mt-5 inline-flex items-center text-sm font-medium text-primary">
                    {item.cta}
                    <ArrowRight className="ml-1.5 h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                  </span>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      <SampleTypeChoices />
      <SamplingLocationsSection className="bg-muted/20" />
    </DrugTestingPageShell>
  );
};

export default Drogtestning;
